import ConvertMeasurement from "./ConvertMeasurement.jsx";
import { IsImperialUnit, IsMetricUnit } from "../Units/AllUnits.jsx";

export function convert(input, isImperial, isMetric, toImperial = undefined, toMetric = undefined) {
  let result = {
    current: null,
    imperial: null,
    metric: null,
  };

  if (IsMetricUnit(input?.unit)) {
    result.metric = Number(input.value);
    result.imperial = Number(
      ConvertMeasurement({
        userInput: input.value,
        from: input.unit,
        to: toImperial,
      })
    );
  }

  if (IsImperialUnit(input?.unit)) {
    result.imperial = Number(input.value);
    result.metric = Number(
      ConvertMeasurement({
        userInput: input.value,
        from: input.unit,
        to: toMetric,
      })
    );
  }

  if (isImperial) {
    result.current = Number(result.imperial);
  }

  if (isMetric) {
    result.current = Number(result.metric);
  }
  return result;
}
